import { getRequest } from './util';

const search = (query, selectedOwnerParty) =>
  getRequest(`/nodes?q=${query}&ownerParty=${selectedOwnerParty}`);

export default {
  search,
};
